import React from 'react'

import { i18n } from '@zet/localization'
import {
  CancelSubscriptionProps,
  CustomBottomSheet,
  useSubscriptionStore,
} from '@zet/zet-prime'

const CancelSubscription = ({
  isVisible,
  onClose,
  setIsCancellationConfirmationModalVisible,
}: CancelSubscriptionProps) => {
  const subscription = useSubscriptionStore((state: any) => state.subscription)

  const handleKeepSubscription = () => {
    onClose()
  }

  const handleCancelSubscription = () => {
    setIsCancellationConfirmationModalVisible(true)
    // TODO: Implement cancel subscription logic
    onClose()
  }

  return (
    <CustomBottomSheet
      isVisible={isVisible}
      onClose={onClose}
      iconImage={require('@zet/zet-prime/assets/images/caution.png')}
      headerText={i18n.t('zetPrime.areYouSureCancelSubscription')}
      subHeaderText={i18n.t('zetPrime.ifYouCancel')}
      earningsWithZetPrime={subscription?.earnings}
      buttons={[
        {
          text: i18n.t('zetPrime.continueEarnings'),
          onPress: handleKeepSubscription,
          variant: 'primary',
        },
        {
          text: i18n.t('zetPrime.cancelAnyway'),
          onPress: handleCancelSubscription,
          textOnly: true,
        },
      ]}
    />
  )
}

export default CancelSubscription
